import { RedirectToSignIn, SignedIn, SignedOut } from '@clerk/clerk-react';
import type { ReactNode } from 'react';

/**
 * Renders children for signed-in users; redirects to Clerk hosted sign-in
 * otherwise. Wraps every route except `/sign-in/*` itself.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}
